import type { MenuData } from 'src/types/types';

const MENU_URL = import.meta.env.VITE_MENU_URL || '/api/menu';

export const fetchMenuData = async (): Promise<MenuData> => {
  const res = await fetch(MENU_URL);

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  return res.json();
};